const TRAINING_DATASET_LIMIT = 12

const STATUS_FILTERS = {
  state_is_empty: 'state is null',
  valid: "state eq 'valid'",
  invalid: "state eq 'invalid'",
}

const buildTrainingDatasetQuery = ({ category, currentPage = 1, search, statusFilter = 'all' }) => {
  const filters = []
  const trimmedSearch = typeof search === 'string' ? search.trim() : ''

  if (category) {
    filters.push(`category eq '${category}'`)
  }

  if (STATUS_FILTERS[statusFilter]) {
    filters.push(STATUS_FILTERS[statusFilter])
  }

  return {
    page: currentPage || 1,
    limit: TRAINING_DATASET_LIMIT,
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
    filters,
  }
}

module.exports = {
  TRAINING_DATASET_LIMIT,
  buildTrainingDatasetQuery,
}

